import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  IconButton,
  Grid,
  Paper
} from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { ModalViewProduct } from './Modal_view_product';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { ImagenesGlobal } from '../global/ImagenesGlobal';

export const ProductoCarruselCuatro = ({
  title = "sin titulo",
  listObjects = [],
  discountPercentage = 0,
  type = "Cuatro",
  openModal,
  loadImageS,
  convertPrice = (() => { }),
}) => {
  const containerRef = useRef(null);
  const [stateImg, setStateImg] = useState(false);
  const [itsActive, setItsActive] = useState(false);

  const [convertedList, setConvertedList] = useState([]);
  const [currentPosition, setCurrentPosition] = useState(0);

  useEffect(() => {
    let separate_lists = [];

    if (type == "Cuatro") {

      const calculo = listObjects.length / 4;
      const vueltas = Math.ceil(calculo);
      let contador = 0;

      for (let iFOR = 0; iFOR < vueltas; iFOR++) {
        let temporal_list = [];
        for (let jFOR = 0; jFOR < 4; jFOR++) {
          temporal_list.push(listObjects[contador] ?? {});

          contador++;
        }
        separate_lists.push(temporal_list);
      }
      setConvertedList(separate_lists);
    }
  }, []);

  useEffect(() => {
    let observer;
    if (convertedList.length > 0) {
      const observer = new IntersectionObserver(([entry]) => {
        setItsActive(entry.isIntersecting);
      },
        {
          root: null, // Observe the viewport
          rootMargin: "0px", // Se puede ajustar para dar margen
          threshold: 0.7, // El porcentaje del elemento visible (en este caso, 50%)
        });

      if (containerRef.current) {
        observer.observe(containerRef.current);
      }
    }


    return () => {
      if (convertedList.length > 0 && containerRef.current) {
        observer.unobserve(containerRef.current);
        // clearInterval(timer);
      }
    };
  }, [convertedList]);

  const itemsLength = (type === "Cuatro") ? convertedList.length : listObjects.length;

  useEffect(() => {
    let timer;
    if (itsActive) {
      timer = setInterval(() => {
        if (type == "Cuatro" && convertedList && convertedList.length > 0) {
          setCurrentPosition(valor => valor < (convertedList.length - 1) ? (valor + 1) : 0);
        }

        if (type == "Uno" && listObjects.length > 1) {
          setCurrentPosition(valor => valor < (listObjects.length - 1) ? (valor + 1) : 0);
        }

      }, type == "Cuatro" ? 4000 : 3000);
    } else {
      clearInterval(timer);
    }

    if (!stateImg) {
      const myFather = containerRef.current?.parentElement?.parentElement;
      if (myFather) {
        setStateImg(window.getComputedStyle(myFather)?.display == "block" ? true : false);
      }
    }

    return () => clearInterval(timer);
  }, [itsActive, convertedList]);

  return (
    <div className='main-container-multi-cards' style={{ maxWidth: '100%', overflow: 'hidden' }} ref={containerRef}>
      <h2>{title}</h2>

      <div className="body-container-four-cards" >
        <ul className='slider-main' style={{
          width: (itemsLength * 100) + '%',
          transform: `translateX(-${itemsLength > 0 ? currentPosition * (100 / itemsLength) : 0}%)`
        }}>
          {
            type == "Cuatro" && convertedList && convertedList.map((children_list, iFOR) => (
              <li className="container-slider-four-prods"> {/*style={{ backgroundColor: 'rgba(250,100,24,0.6', border: '1px solid black' }} */}
                {
                  children_list.map((obj) => {
                    return (
                      obj.img_list ? (
                        <div className="cards shadow-lvl6" onClick={() => openModal(obj)}>
                          <div className="cards-img">
                            <ImagenesGlobal url={obj.img_list[0]} type={'picture'} loadImageS={loadImageS} />
                          </div>
                          <CardContent
                            sx={{
                              "boxShadow": "none",
                            }}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "space-between",
                              padding: '5px 10px',
                            }}
                          >
                            <Typography
                              variant="body2"
                              style={{
                                fontWeight: "bold",
                                fontSize: "0.8rem",
                                textAlign: "left",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                lineHeight: "1.2em",
                                height: "2.4em",
                                flex: 1,
                                color: '#000'
                              }}
                              title={obj.product_name}>
                              {obj.product_name}
                            </Typography>

                            {discountPercentage > 0 ? (
                              <div style={{ textAlign: "right", display: "flex", flexDirection: "column" }}>
                                <Typography
                                  variant="caption"
                                  sx={{ fontSize: "0.7rem", textDecoration: "line-through", color: "#999" }}
                                >
                                  {convertPrice(obj.sale_price, obj?.currency)}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="green"
                                  sx={{ fontSize: "0.75rem", fontWeight: 600 }}
                                >
                                  {(convertPrice(obj.sale_price) * (1 - discountPercentage / 100), obj?.currency)}
                                </Typography>
                              </div>
                            ) : (
                              <Typography
                                variant="caption"
                                color="green"
                                sx={{ fontSize: "0.75rem", fontWeight: 600, whiteSpace: "nowrap" }}
                              >
                                {convertPrice(obj.sale_price, obj?.currency)}
                              </Typography>
                            )}
                          </CardContent>
                        </div>
                      ) : (
                        <div className="cards">

                        </div>
                      )
                    )
                  })
                }
              </li>
            ))
          }

          {
            type == "Uno" && (Array.isArray(listObjects)) && listObjects.map((obj) => (
              <li className='container-slider-one-prods'>
                <div className="cards shadow-lvl6" onClick={() => openModal(obj)}>
                  <div className="cards-img">
                    <ImagenesGlobal url={obj.img_list[0]} type={'picture'} loadImageS={loadImageS} />
                  </div>
                  <CardContent
                    sx={{
                      "boxShadow": "none",
                    }}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      padding: '5px 10px',
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{
                        fontWeight: "bold",
                        fontSize: "0.8rem",
                        textAlign: "left",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: "1.2em",
                        height: "2.4em",
                        flex: 1,
                        color: '#000'
                      }}
                      title={obj.product_name}>
                      {obj.product_name}
                    </Typography>

                    {discountPercentage > 0 ? (
                      <div style={{ textAlign: "right", display: "flex", flexDirection: "column" }}>
                        <Typography
                          variant="caption"
                          sx={{ fontSize: "0.7rem", textDecoration: "line-through", color: "#999" }}
                        >
                          {convertPrice(obj.sale_price, obj?.currency)}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="green"
                          sx={{ fontSize: "0.75rem", fontWeight: 600 }}
                        >
                          {(convertPrice(obj.sale_price) * (1 - discountPercentage / 100), obj?.currency)}
                        </Typography>
                      </div>
                    ) : (
                      <Typography
                        variant="caption"
                        color="green"
                        sx={{ fontSize: "0.75rem", fontWeight: 600, whiteSpace: "nowrap" }}
                      >
                        {convertPrice(obj.sale_price, obj?.currency)}
                      </Typography>
                    )}
                  </CardContent>
                </div>
              </li>
            ))
          }
        </ul>
      </div>

      {
        ((type == "Cuatro" && convertedList.length > 1) || (type == "Uno" && listObjects.length > 1)) && (<div className="control-list">
          <IconButton className="icons-modal-p" onClick={() => setCurrentPosition(valor => valor > 0 ? (valor - 1) : 0)} sx={{ height: 'calc(5px + var(--size-icon))', width: 'calc(5px + var(--size-icon))' }}>
            <NavigateBeforeIcon sx={{ color: '#fff' }} style={{ fontSize: 'var(--size-icon)' }} />
          </IconButton>

          <IconButton className="icons-modal-p" onClick={() => setCurrentPosition(valor => valor < ((type == "Cuatro" ? convertedList : listObjects).length - 1) ? (valor + 1) : 0)} sx={{ height: 'calc(5px + var(--size-icon))', width: 'calc(5px + var(--size-icon))' }}>
            <NavigateNextIcon sx={{ color: '#fff' }} style={{ fontSize: 'var(--size-icon)' }} />
          </IconButton>
        </div>)
      }
    </div>
  )
};


{/* <CardContent
                      sx={{
                        "boxShadow": "none",
                      }}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        padding: '5px 10px',
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: "bold",
                          fontSize: "0.8rem",
                          textAlign: "left",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          lineHeight: "1.2em",
                          height: "2.4em",
                          flex: 1,
                        }}
                        title={obj.product_name}>
                        {obj.product_name}
                      </Typography>

                      {discountPercentage > 0 ? (
                        <div style={{ textAlign: "right", display: "flex", flexDirection: "column" }}>
                          <Typography
                            variant="caption"
                            sx={{ fontSize: "0.7rem", textDecoration: "line-through", color: "#999" }}
                          >
                            Bs. {parseFloat(obj.sale_price).toFixed(2)}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="green"
                            sx={{ fontSize: "0.75rem", fontWeight: 600 }}
                          >
                            Bs. {(parseFloat(obj.sale_price) * (1 - discountPercentage / 100)).toFixed(2)}
                          </Typography>
                        </div>
                      ) : (
                        <Typography
                          variant="caption"
                          color="green"
                          sx={{ fontSize: "0.75rem", fontWeight: 600, whiteSpace: "nowrap" }}
                        >
                          Bs. {parseFloat(obj.sale_price).toFixed(2)}
                        </Typography>
                      )}
                    </CardContent> */}